export const locale = {
    lang: 'en',
    data: {
        EDIT_PARAGRAPHE: 'Edit paragraph',
        TITLE: 'Title',
        SAVE: 'Save',
        CANCEL: 'Cancel',
    }
};
